import router from '@/vue/router/';
import store from '../../vue/vuex/store'
import { url } from "@/assets/js/config";
import Vue from 'vue';

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

const goBack = function () {
    if (this.$store.state.fromUrl) {
        router.go(-1)
    } else {
        router.push({ path: '/' })
    }
}



const debounce = (func, wait, immediate) => {
    let timeout, args, context, timestamp, result;
    return function () {
        context = this;
        args = arguments;
        timestamp = new Date();
        const later = () => {
            const last = (new Date()) - timestamp;
            if (last < wait) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                result = func.apply(context, args);
            }
        };
        if (!timeout) {
            timeout = setTimeout(later, wait);
        }
        return result;
    };
}

const throttle = (func, wait, options) => {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function () {
        previous = options.leading === false ? 0 : new Date();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null; //显示地释放内存，防止内存泄漏
    };

    var throttled = function () {
        var now = new Date();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };

    throttled.cancel = function () {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

const IsPC = function () {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

const getELTime = function (value, format) {
    if (!value) { return '' }
    // value = value.replace('T', ' ');
    switch (typeof value) {
        case "string":
            value = new Date(value.replace(/-/g, "/"));
            break;
        case "number":
            value = new Date(value);
            break;
    }
    if (!value instanceof Date) return '';
    var dict = {
        "yyyy": value.getFullYear(),
        "MM": ("" + (value.getMonth() + 101)).substr(1),
        "dd": ("" + (value.getDate() + 100)).substr(1),
        "HH": ("" + (value.getHours() + 100)).substr(1),
        "mm": ("" + (value.getMinutes() + 100)).substr(1),
        "ss": ("" + (value.getSeconds() + 100)).substr(1),
        "M": value.getMonth() + 1,
        "d": value.getDate(),
        "H": value.getHours(),
        "m": value.getMinutes(),
        "s": value.getSeconds()

    };
    for (var k in dict) {
        if (format.indexOf(k) >= 0) {
            format = format.replace(k, dict[k]);
        }
    }
    return format;
}

const isAdmin = function () {
    if (!this.$store.state.user.roles) {
        return false
    }
    for (let i = 0; i < this.$store.state.user.roles.length; i++) {
        if (this.$store.state.user.roles[i] == 'sysAdmin') {
            return true
        }
    }
    return false
}

const guid = function (len) {
    //时间戳
    let time = new Date().getTime() + ""

    var chars = '0123456789abcdefghigklmnopqrstuvwxyzABCDEFGHIGKLMNOPQRSTUVWXYZ'.split(''),
        radix = chars.length,
        qutient = [],
        arr = [];

    //因为时间戳的前几位较为固定 所以将其倒转过来
    qutient = parseInt(time.split("").reverse().join(""));

    do {
        let mod = qutient % radix;
        qutient = (qutient - mod) / radix;
        arr.unshift(chars[mod]);
    } while (qutient);

    //时间戳生成的62进制最大为八位  不足八位则补足  并在最后一位标记补足的位数
    var num = 0
    for (var i = 0; i < 8 - arr.length; i++) {
        num++
        arr.push(chars[0 | Math.random() * radix])
    }
    arr.push(num + '')

    //当前arr为9位(1位时间戳+1位标记)
    //生成9位随机字符插入其中
    var guArr = []
    for (var j = 0; j < 9; j++) {
        guArr.push(chars[0 | Math.random() * radix])
        guArr.push(arr[j])
    }

    // 当前guArr为18位
    if (!len || len <= 18) {
        //如果小于等于18  则直接返回
    } else {
        //大于18 则要在后面加上随机字符串
        for (var k = 0; k < len - 18; k++) {
            guArr.push(chars[0 | Math.random() * radix])
        }
    }

    return guArr.join('');
}

const guidTime = function (format) {
    let value = new Date();
    if (!format) {
        format = "yyyyMMdd"
    }

    switch (typeof value) {
        case "string":
            value = new Date(value.replace(/-/g, "/"));
            break;
        case "number":
            value = new Date(value);
            break;
    }
    if (!value instanceof Date) return '';
    var dict = {
        "yyyy": value.getFullYear(),
        "MM": ("" + (value.getMonth() + 101)).substr(1),
        "dd": ("" + (value.getDate() + 100)).substr(1),
        "HH": ("" + (value.getHours() + 100)).substr(1),
        "mm": ("" + (value.getMinutes() + 100)).substr(1),
        "ss": ("" + (value.getSeconds() + 100)).substr(1),
        "M": value.getMonth() + 1,
        "d": value.getDate(),
        "H": value.getHours(),
        "m": value.getMinutes(),
        "s": value.getSeconds()

    };
    for (var k in dict) {
        if (format.indexOf(k) >= 0) {
            format = format.replace(k, dict[k]);
        }
    }
    return format;
}

const newPassword = function (len = 10) {
    if (!len || len < 3) {
        console.error('密码长度不得低于3位');
        return
    }

    let chars = '0123456789abcdefghigklmnopqrstuvwxyzABCDEFGHIGKLMNOPQRSTUVWXYZ'.split(''),
        big = 'ABCDEFGHIGKLMNOPQRSTUVWXYZ'.split(''),
        small = 'abcdefghigklmnopqrstuvwxyz'.split(''),
        numbers = '0123456789'.split(''),
        arr = [];

    for (let i = 0; i < len; i++) {
        let c = chars[Math.floor(Math.random() * chars.length)];
        arr.push(c)
    }

    //随机选取一个大写字符 小写字符 和数字
    let b = big[Math.floor(Math.random() * big.length)];
    let s = small[Math.floor(Math.random() * small.length)];
    let n = numbers[Math.floor(Math.random() * numbers.length)];

    //替换三个原有的字符  先获取三个index
    let index1, index2, index3;

    index1 = Math.floor(Math.random() * len);

    for (; index2 === undefined;) {
        let a = Math.floor(Math.random() * len);
        if (a !== index1) {
            index2 = a;
        }
    }
    for (; index3 === undefined;) {
        let a = Math.floor(Math.random() * len);
        if (a !== index1 && a !== index2) {
            index3 = a;
        }
    }

    //然后替换
    arr[index1] = b;
    arr[index2] = s;
    arr[index3] = n;

    //转成字符串
    return arr.join('');
}

const addHistory = function (path,query) {
    let arr = store.state.historyList;
    

    //添加当前页面 如果已经有了  就不再添加一个了
    let obj = {...router.history.current}
    let tips = true;
    for(let i = 0;i < arr.length;i ++){
        if(arr[i].meta.navName == obj.meta.navName){
            tips = false;
        }
    }
    if(tips){
        store.state.historyList.push(obj)
    }

    
    //添加目标页面 如果已经有了  就不再添加一个了
    let obj2 = {}
    // 先找到对象
    for(let i = 0;i < router.options.routes.length;i ++){
        if(path == router.options.routes[i].path){
            obj2 = router.options.routes[i]
        }
    }

    let tips2 = true;
    for(let i = 0;i < arr.length;i ++){
        if(arr[i].meta.navName == obj2.meta.navName){
            tips2 = false;
        }
    }
    if(tips2){
        store.state.historyList.push(obj2)
    }
    
    router.push(path + query);
}

const clearHistory = function () {
    store.state.historyList = [];
}

const noRefresh = function(){
    let obj = {...router.history.current};
    if(obj.query.refresh == 'no'){
        router.replace(obj.path);
        return true
    }else{
        return false
    }
}
const downLoad = function (id){
    Vue.prototype.$reqPost("/api/file/downloadCode/get", {
        id:id
    }).then(
        res => {
            if (res.data.returnData) {
                let str = `${url().baseUrl}/api/file/downloadFile`;

                //JavaScript版
                var f = document.createElement("form");
                document.body.appendChild(f);

                var i = document.createElement("input");
                i.type = "hidden";
                f.appendChild(i);
                i.value = res.data.returnData;
                i.name = "code";

                f.action = str; //下载的url 地址
                f.submit();

                document.body.removeChild(f);
            }
        },
        err => {}
    );
}

export default {
    install(Vue) {
        Vue.prototype.$goBack = goBack,
            Vue.prototype.$debounce = debounce,
            Vue.prototype.$throttle = throttle,
            Vue.prototype.$IsPC = IsPC,
            Vue.prototype.$getELTime = getELTime,
            Vue.prototype.$isAdmin = isAdmin,
            Vue.prototype.$guid = guid,
            Vue.prototype.$guidTime = guidTime,
            Vue.prototype.$newPassword = newPassword,
            Vue.prototype.$addHistory = addHistory,
            Vue.prototype.$clearHistory = clearHistory,
            Vue.prototype.$downLoad = downLoad,
            Vue.prototype.$noRefresh = noRefresh
    },
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js